export * from "modules/TyreDiscountsDashboard/components/DeleteTyreBrandDiscountModal/hooks/useDeleteTyreBrandDiscountMutation";
